import { Divider } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledDivider = styled(Divider)`
    margin-left: ${({ theme }) => theme.spacing(1)};
    margin-right: ${({ theme }) => theme.spacing(1)};
`

export default StyledDivider
